import { RxIconModule } from '@nrwl/rx-icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxUploadService } from './rx-upload.service';
import { RxUploadZoneComponent } from './rx-upload-zone/rx-upload-zone.component';
import { RxUploadZoneDirective } from './rx-upload-zone/rx-upload-zone.directive';
import { RxUploadDirective } from './rx-upload-directive/rx-upload.directive';
import { RxUploaderPreviewComponent } from './rx-upload-preview';
import { RxRowModule } from '@nrwl/rx-row';
import { RxColModule } from '@nrwl/rx-col';
import { RxButtonModule } from '@nrwl/rx-button';
import { Ng2ImgMaxModule } from 'ng2-img-max';

@NgModule({
  imports: [
    CommonModule,
    RxRowModule,
    RxColModule,
    RxButtonModule,
    RxIconModule,
    Ng2ImgMaxModule,
    RxUploadZoneComponent,
    RxUploadZoneComponent,
    RxUploaderPreviewComponent,
    RxUploadZoneDirective,
    RxUploadDirective,
  ],
  exports: [RxUploadZoneComponent, RxUploadDirective, RxUploaderPreviewComponent],
  providers: [RxUploadService],
})
export class RxUploadModule {}
